type Props = {
  label?: string;
  value?: string | number;
};

const InfoField = ({ label, value }: Props) => {
  return (
    <div>
      {label && (
        <label htmlFor={label} className="my-2 block text-[14px] font-[600]">
          {label}
        </label>
      )}
      <div className="mb-2 flex w-full items-center justify-between">
        <p className="text-xs text-graydark">{value ? value.toString() : ''}</p>
      </div>
    </div>
  );
};

export default InfoField;
